import {LiveStreamingListTitleDefaultBox} from "./live-streaming-list-title.default.box";

export const LiveStreamingListTitleBox = LiveStreamingListTitleDefaultBox;
